export function isIGotoLoggerMessage(message) {
    return ('ts' in message &&
        'seq' in message &&
        'origin' in message &&
        'category' in message &&
        'data' in message);
}
//# sourceMappingURL=i-goto-logger-message.js.map